import React from 'react'
import styled from 'styled-components'
import { navigationPropTypes } from './NavBar'
import vars from '../lib/styled'
import * as Accessa from 'accessa'
import leaf from '../../static/leaf.png'

const OffcanvasWrapper = styled.div`
  display: none;

  svg {
    fill: ${({ scroll }) => (scroll ? vars.contrast : 'currentColor')};
    transition: fill 150ms ease-in;
  }

  @media (max-width: ${vars.breakpoint.laptop}) {
    background-color: ${({ scroll }) =>
      scroll ? vars.primary : 'transparent'};
    border-radius: 50%;
    padding: 0.45rem;
    display: flex;
    align-items: center;
    position: fixed;
    transition: background 150ms ease-in;
    right: 2rem;
    z-index: 100;
  }
`

const LinkFix = styled.div`
  margin-top: 2rem;

  a {
    box-sizing: border-box;
  }
`

const OffcanvasDrawer = ({ menuItems, locale }) => {
  const [scroll, setScroll] = React.useState(false)
  const handleScroll = () => {
    if (window.scrollY !== 0) {
      setScroll(true)
    } else {
      setScroll(false)
    }
  }

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll, {
      passive: true,
    })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <OffcanvasWrapper scroll={scroll}>
      <Accessa.Navigation.Offcanvas
        logo={
          <img
            alt="Marcangelo Logo Leaf"
            src={leaf}
            style={{ width: 45, marginLeft: '1rem' }}
          />
        }
      >
        <LinkFix>
          <Accessa.Navigation.Tree
            items={menuItems[locale.replace(/-/, '_')].map((obj) => {
              obj.href = `/${locale}${obj.link}`
              return obj
            })}
          />
        </LinkFix>
      </Accessa.Navigation.Offcanvas>
    </OffcanvasWrapper>
  )
}

OffcanvasDrawer.propTypes = navigationPropTypes
export default OffcanvasDrawer
